import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Eye, EyeSlash } from '@phosphor-icons/react';
import { toast } from 'sonner';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const result = await login(email, password);
    
    if (result.success) {
      toast.success('¡Inicio de sesión exitoso!');
      navigate('/dashboard');
    } else {
      toast.error(result.error || 'Credenciales inválidas');
    }
    
    setIsLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0d0f14] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <img 
            src="/logo-visionweb.png" 
            alt="VisionWeb" 
            className="h-20 mx-auto"
            style={{ background: 'transparent' }}
          />
        </div>

        {/* Login Form */}
        <div className="bg-[#13161e] border border-[#2a2e3d] rounded-md p-8">
          <h2 className="text-white font-['Fraunces'] text-2xl font-bold mb-6" data-testid="login-title">Iniciar Sesión</h2>
          
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-[#8b949e] font-['IBM_Plex_Mono'] text-xs uppercase tracking-wider block mb-2">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-[#0d0f14] border border-[#2a2e3d] rounded-sm px-4 py-2 text-white font-['Mulish'] text-sm focus:border-[#4f9eff] focus:outline-none transition-colors"
                placeholder="correo@ejemplo.com"
                required
                data-testid="login-email-input"
              />
            </div>

            <div>
              <label className="text-[#8b949e] font-['IBM_Plex_Mono'] text-xs uppercase tracking-wider block mb-2">
                Contraseña
              </label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full bg-[#0d0f14] border border-[#2a2e3d] rounded-sm px-4 py-2 text-white font-['Mulish'] text-sm focus:border-[#4f9eff] focus:outline-none transition-colors"
                  placeholder="••••••••"
                  required
                  data-testid="login-password-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-[#8b949e] hover:text-white transition-colors"
                  data-testid="toggle-password-visibility"
                >
                  {showPassword ? <EyeSlash size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-[#4f9eff] text-[#0d0f14] rounded-sm px-4 py-3 font-['IBM_Plex_Mono'] text-sm font-bold hover:bg-[#4f9eff]/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              data-testid="login-submit-button"
            >
              {isLoading ? 'Cargando...' : 'Iniciar Sesión'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
